import * as React from 'react'
import {memo} from 'react'

import {usePermission} from '../../../../hooks/usePermission'
import {getBuild, getBuildType} from '../../../../selectors'
import {Permission} from '../../../../types'
import type {Props as BuildDetailsProps} from '../../../common/Builds/BuildDetails/BuildDetails.types'
import {usePage} from '../../../common/Pager/Pager.hooks'

import type {QueueBuildDragItem} from './QueueBuild'
import QueueBuild from './QueueBuild'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = BuildDetailsProps & {
  prevBuildId: number | undefined
  nextBuildId: number | undefined
  isQueued: boolean
  hoveredDropBuildId: number | undefined
  droppedBuildId: number | undefined
  setHoveredDropBuildId: (buildId: number | undefined) => void
  onDrop: (item: QueueBuildDragItem) => void
}

function QueueBuildContainer(props: Props) {
  const {
    buildId,
    hoveredDropBuildId,
    droppedBuildId,
    prevBuildId,
    nextBuildId,
    alwaysShowLineBorders,
    isQueued,
    wrapped,
    pathFilter,
    setHoveredDropBuildId,
    onDrop,
  } = props

  const buildType = useAppSelector(state => getBuild(state, buildId)?.buildType)
  const projectId = useAppSelector(state => getBuildType(state, buildType)?.projectId)
  const page = usePage()
  const isDraggable = usePermission(Permission.REORDER_BUILD_QUEUE, projectId) && page === 1

  return (
    <QueueBuild
      isDraggable={isDraggable}
      hoveredDropBuildId={hoveredDropBuildId}
      setHoveredDropBuildId={setHoveredDropBuildId}
      droppedBuildId={droppedBuildId}
      prevBuildId={prevBuildId}
      nextBuildId={nextBuildId}
      buildId={buildId}
      alwaysShowLineBorders={alwaysShowLineBorders}
      isQueued={isQueued}
      wrapped={wrapped}
      pathFilter={pathFilter}
      onDrop={onDrop}
    />
  )
}

export default memo(QueueBuildContainer)
